import { MeasurementPersonListContainer } from '../containers/MeasurementPersonListContainer/index'

export const MeasurementPersonListPage = () => (
    <MeasurementPersonListContainer/>
)
